import React, { Component } from 'react';
import { Button } from 'reactstrap';
import './Home.css';
import { JEAN_PIAGET_LOGO_DATA_URI } from '../assets/brandAssets';
import { WelcomeHome } from './WelcomeHome';
import { storeSession, isAuthenticated, login } from '../services/authService';

function InputIcon({ children }) {
    return (
        <span className="login-page__input-icon" aria-hidden="true">
            {children}
        </span>
    );
}

function UserIcon() {
    return (
        <svg className="login-page__field-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M20 21a8 8 0 0 0-16 0" />
            <circle cx="12" cy="8" r="4" />
        </svg>
    );
}

function LockIcon() {
    return (
        <svg className="login-page__field-icon" viewBox="0 0 24 24" aria-hidden="true">
            <rect x="5" y="11" width="14" height="10" rx="2" />
            <path d="M8 11V8a4 4 0 0 1 8 0v3" />
        </svg>
    );
}

function PasswordToggleIcon({ visible }) {
    if (visible) {
        return (
            <svg className="login-page__password-icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
                <circle cx="12" cy="12" r="3" />
            </svg>
        );
    }

    return (
        <svg className="login-page__password-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c6.5 0 10 7 10 7a18.2 18.2 0 0 1-2.16 3.19" />
            <path d="M6.06 6.06A18.2 18.2 0 0 0 2 12s3.5 7 10 7a10.94 10.94 0 0 0 5.24-1.34" />
            <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
            <path d="M1 1l22 22" />
        </svg>
    );
}

export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        this.state = {
            usuario: '',
            contrasenia: '',
            showPassword: false,
            loading: false,
            errorMessage: '',
            sucess: isAuthenticated()
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDNIChangeInput = this.handleDNIChangeInput.bind(this);
        this.handleNameChangeInput = this.handleNameChangeInput.bind(this);
        this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
        this.onLogout = this.onLogout.bind(this);
    }

    componentDidMount() {
        window.addEventListener('logout', this.onLogout);
    }

    componentWillUnmount() {
        window.removeEventListener('logout', this.onLogout);
    }

    onLogout() {
        this.setState({
            sucess: isAuthenticated(),
            usuario: '',
            contrasenia: '',
            showPassword: false
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.state.loading) {
            return;
        }
        if (this.isOkToSave()) {
            this.authenticateUser();
        } else {
            this.setState({ errorMessage: 'Ingrese usuario y contraseña por favor' });
        }
    }

    handleDNIChangeInput(e) {
        this.setState({ usuario: e.target.value });
    }

    handleNameChangeInput(e) {
        this.setState({ contrasenia: e.target.value });
    }

    togglePasswordVisibility() {
        this.setState(prev => ({ showPassword: !prev.showPassword }));
    }

    isOkToSave() {
        return this.state.contrasenia.length > 0 && this.state.usuario.length > 0;
    }

    render() {
        if (this.state.sucess) {
            return <WelcomeHome />;
        }

        const { loading, errorMessage, usuario, contrasenia, showPassword } = this.state;
        const showError = errorMessage.length > 0 && !loading;

        return (
            <div className="login-page">
                <header className="login-page__header">
                    <img
                        src={JEAN_PIAGET_LOGO_DATA_URI}
                        alt="Instituto Jean Piaget"
                        className="login-page__logo"
                    />
                    <h1 className="login-page__title">Instituto Jean Piaget N°8048</h1>
                    <p className="login-page__subtitle">Sistema de Gestión Académica</p>
                </header>

                <div className="login-page__card">
                    <form className="login-page__form" onSubmit={this.handleSubmit} noValidate>
                        <div
                            className="login-page__feedback"
                            aria-live="polite"
                            role="status"
                        >
                            {showError ? (
                                <span className="login-page__error">{errorMessage}</span>
                            ) : null}
                            {loading ? (
                                <span className="login-page__loading">
                                    Estamos validando sus datos, espere unos segundos...
                                </span>
                            ) : null}
                        </div>

                        <div className="login-page__field">
                            <label className="login-page__label" htmlFor="login-usuario">
                                Usuario
                            </label>
                            <div className="login-page__input-wrap">
                                <InputIcon><UserIcon /></InputIcon>
                                <input
                                    id="login-usuario"
                                    className="login-page__input login-page__input--with-icon"
                                    name="usuario"
                                    type="text"
                                    placeholder="Ingrese su usuario"
                                    autoComplete="username"
                                    disabled={loading}
                                    value={usuario}
                                    onChange={this.handleDNIChangeInput}
                                />
                            </div>
                        </div>

                        <div className="login-page__field">
                            <label className="login-page__label" htmlFor="login-contrasenia">
                                Contraseña
                            </label>
                            <div className="login-page__input-wrap login-page__password-wrap">
                                <InputIcon><LockIcon /></InputIcon>
                                <input
                                    id="login-contrasenia"
                                    className="login-page__input login-page__input--with-icon login-page__input--password"
                                    name="contrasenia"
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Ingrese su contraseña"
                                    autoComplete="current-password"
                                    disabled={loading}
                                    value={contrasenia}
                                    onChange={this.handleNameChangeInput}
                                />
                                <button
                                    type="button"
                                    className="login-page__password-toggle"
                                    onClick={this.togglePasswordVisibility}
                                    disabled={loading}
                                    aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                                    aria-pressed={showPassword}
                                >
                                    <PasswordToggleIcon visible={showPassword} />
                                </button>
                            </div>
                        </div>

                        <Button
                            type="submit"
                            color="primary"
                            className="login-page__submit"
                            disabled={loading}
                        >
                            Ingresar
                        </Button>
                    </form>
                </div>
            </div>
        );
    }

    async authenticateUser() {
        this.setState({ errorMessage: '', loading: true });
        const { data } = await login(this.state.usuario, this.state.contrasenia);
        let errorMessage = '';
        if (data.errorMessage || data === 'Forbidden.') {
            const error = data.errorMessage ? data.errorMessage : 'Forbidden.';
            errorMessage = 'Ocurrió un error al ejecutar la operación: ' + error;
        } else if (!storeSession(data, this.state.usuario)) {
            errorMessage = 'Usuario y/o contraseña inválidos';
        }
        this.setState({ loading: false, sucess: isAuthenticated(), errorMessage: errorMessage });
    }
}
